import React from 'react'
import PropTypes from 'prop-types'
import styles from './BackLink.module.scss'
import classnames from 'classnames'
import Link from 'redux-first-router-link'
import { trackAnalyticsEvent } from 'analytics'

const BackLink = (props) => {
  const { path, text, className } = props
  const backText = `< Back: ${text}`
  const linkStyles = classnames(styles.BackLink, className)
  return (
    <Link
      data-test="prevPageInfo"
      className={linkStyles}
      onClick={() => trackAnalyticsEvent(`Back to ${text} Clicked`)}
      to={path}>
      {backText}
    </Link>
  )
}

BackLink.defaultProps = {
  text: null,
  path: null,
  className: null
}

BackLink.propTypes = {
  text: PropTypes.string,
  path: PropTypes.string,
  className: PropTypes.string
}

export default BackLink



// WEBPACK FOOTER //
// ./src/components/Shared/BackLink/BackLink.jsx